<template :key="componentKey">
  <div>

    <v-navigation-drawer
      app dark
      :expand-on-hover="$vuetify.breakpoint.mdAndUp"
      hide-overlay
      permanent
      :mini-variant="mini"
      :class="backgroundColor()"
    >
      <template v-slot:prepend>
        <v-list>
          <v-list-item v-if="$vuetify.breakpoint.mdAndUp"
                       link
                       two-line
                       to="/settings">
            <v-list-item-content>
              <v-list-item-title class="title">{{name}}</v-list-item-title>
              <v-list-item-subtitle>{{$store.getters['auth/user_email']}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="$vuetify.breakpoint.smAndDown">
            <v-list-item-icon>
              <v-btn icon @click="mini = !mini">
                <v-icon>{{mini ? 'fas fa-bars' : 'clear'}}</v-icon>
              </v-btn>
            </v-list-item-icon>
            <v-list-item-title link to="/settings">
              {{name}}
            </v-list-item-title>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
      </template>

<!--      <div v-bar class="el1full">-->
        <v-list nav dense>
          <v-list-item link to='/'>
            <v-list-item-icon>
              <v-icon>fas fa-home</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item>

          <v-list-group
            prepend-icon="fas fa-truck"
            color="white"
            v-if="itemsSubheaderDelivery"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>Delivery</v-list-item-title>
              </v-list-item-content>
            </template>

            <v-divider></v-divider>
            <div style="background-color: #ffffff1a">
              <v-list-item
                v-for="(item, deliveryIndex) in itemsSubheaderDelivery"
                :to="item.path"
                :key="'delivery'+ deliveryIndex"
              >
                <v-list-item-icon>
                  <v-icon>{{item.icon}}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{item.name}}</v-list-item-title>
              </v-list-item>
            </div>
            <v-divider></v-divider>
          </v-list-group>

          <v-list-group
            prepend-icon="fas fa-tasks"
            color="white"
            v-if="itemsSubheaderManage"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>Manage</v-list-item-title>
              </v-list-item-content>
            </template>

            <v-divider></v-divider>
            <div style="background-color: #ffffff1a">
              <v-list-item
                v-for="(item, ManageIndex) in itemsSubheaderManage"
                :to="item.path"
                :key="'manage'+ ManageIndex"
              >
                <v-list-item-icon>
                  <v-icon>{{item.icon}}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{item.name}}</v-list-item-title>
              </v-list-item>
            </div>
            <v-divider></v-divider>
          </v-list-group>


          <v-list-group
            prepend-icon="fas fa-user-cog"
            color="white"
            v-if="itemsSubheaderAdmin"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>Admin</v-list-item-title>
              </v-list-item-content>
            </template>

            <v-divider></v-divider>
            <div style="background-color: #ffffff1a">
              <v-list-item
                v-for="(item, adminIndex) in itemsSubheaderAdmin"
                :to="item.path"
                :key="'admin'+ adminIndex"
              >
                <v-list-item-icon>
                  <v-icon>{{item.icon}}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{item.name}}</v-list-item-title>
              </v-list-item>
            </div>
            <v-divider></v-divider>
          </v-list-group>

          <v-list-group
            prepend-icon="fas fa-dolly-flatbed"
            color="white"
            v-if="itemsSubheaderInventory"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>Inventory</v-list-item-title>
              </v-list-item-content>
            </template>

            <v-divider></v-divider>
            <div style="background-color: #ffffff1a">
              <v-list-item
                v-for="(item, subIndex) in itemsSubheaderInventory"
                :to="item.path"
                :key="subIndex"
              >
                <v-list-item-icon>
                  <v-icon>{{item.icon}}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{item.name}}</v-list-item-title>
              </v-list-item>
            </div>
            <v-divider></v-divider>
          </v-list-group>

          <v-list-group
            prepend-icon="fas fa-dollar-sign"
            color="white"
            v-if="itemsSubheaderClientPricing"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>Client pricing</v-list-item-title>
              </v-list-item-content>
            </template>

            <v-divider></v-divider>
            <div style="background-color: #ffffff1a">
              <v-list-item
                v-for="(item, subIndex) in itemsSubheaderClientPricing"
                :to="item.path"
                :key="'clientPricing'+ subIndex"
              >
                <v-list-item-icon>
                  <v-icon>{{item.icon}}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{item.name}}</v-list-item-title>
              </v-list-item>
            </div>
            <v-divider></v-divider>
          </v-list-group>

          <v-list-group
            prepend-icon="fas fa-calculator"
            color="white"
            v-if="itemsSubheaderClientTools"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>Client tools</v-list-item-title>
              </v-list-item-content>
            </template>

            <v-divider></v-divider>
            <div style="background-color: #ffffff1a">
              <v-list-item
                v-for="(item, subIndex) in itemsSubheaderClientTools"
                :to="item.path"
                :key="subIndex"
              >
                <v-list-item-icon>
                  <v-icon>{{item.icon}}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{item.name}}</v-list-item-title>
              </v-list-item>
            </div>
            <v-divider></v-divider>
          </v-list-group>

          <v-list-item link v-if="hasAPIDocumentationPermission" @click="goApi">
            <v-list-item-icon>
              <v-icon>fas fa-book</v-icon>
            </v-list-item-icon>
            <v-list-item-title>API Documentation</v-list-item-title>
          </v-list-item>

          <v-list-item link to='/faq'>
            <v-list-item-icon>
              <v-icon>fas fa-question</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>API FAQ</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item link v-if="switchClientPermission" @click="changeClientDialog=true">
            <v-list-item-icon>
              <v-icon>fas fa-exchange-alt</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Change Client</v-list-item-title>
          </v-list-item>

          <v-list-item link v-if="switchUserPermission" @click="changeUserDialog=true">
            <v-list-item-icon>
              <v-icon>fas fa-exchange-alt</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Change User</v-list-item-title>
          </v-list-item>
        </v-list>
<!--      </div>-->

      <template v-slot:append>
        <v-list
          nav
          dense
        >
          <v-list-item link @click="logout">
            <v-list-item-icon>
              <v-icon>logout</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </template>

    </v-navigation-drawer>

    <v-dialog
      v-model="changeUserDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          <h3>Choose a User</h3>
        </v-card-title>
        <v-card-text>
          <v-autocomplete
            hide-no-data
            v-model="user"
            :items="users"
            item-text="username"
            label="Choose the User"
            return-object
          >
          </v-autocomplete>
        </v-card-text>
        <v-card-actions :class="$vuetify.breakpoint.smAndDown ? 'flex-column' : 'justify-center'">
          <v-btn text color="teal accent-4" @click="goBackToInitialUser" v-if="this.switched_user">
            <v-icon left>arrow_back</v-icon>
            Go back to my initial user
          </v-btn>
          <v-btn text color="blue-grey lighten-2" @click="changeUserDialog=false">
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="changeUser">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog
      v-model="changeClientDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          <h3>Choose a Client</h3>
        </v-card-title>
        <v-card-text>
          <v-autocomplete
            hide-no-data
            v-model="client"
            :items="clients"
            item-text="name"
            label="Choose the Client"
            return-object
          >
          </v-autocomplete>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text color="teal accent-4" @click="goBackToInitialClient" v-if="this.switched_client">
            <v-icon left>arrow_back</v-icon>
            Go back to my initial user
          </v-btn>
          <v-btn text color="blue-grey lighten-2" @click="changeClientDialog=false">
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="changeClient">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog">
      <v-card style="background-color: #ECEFF1">
        <v-card-title class="display-1 justify-center">ERROR</v-card-title>
        <v-dialog color="#42a5f5"></v-dialog>
        <v-card-text class="text-center">
          An error has occurred. ({{message}})
        </v-card-text>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
    import axios from 'axios';
    import router from '../../modules/router';
    import {createNamespacedHelpers} from 'vuex';

    const {mapState: authState, mapMutations: authMutations, mapGetters: authGetters, mapActions: authActions} = createNamespacedHelpers("auth");
    import getStopsFromTracking from "../pages/Delivery/Search.vue";

    export default {
        name: 'InternalMenu',
        data() {
            return {
                dialog: false,
                message: '',
                Items: router.routes,
                tracking: '',
                mini: false,
                headers: [
                    {text: 'Client Name', value: 'clientName'},
                    {text: 'Address', value: 'address'},
                    {text: 'Region', value: 'region'},
                    {text: 'Invoice No', value: 'invoice'},
                    {text: 'Tracking Id', value: 'tracking'},
                ],
                footers: [
                    'Contact Us'
                ],
                redirect: 'home',
                changeUserDialog: false,
                changeClientDialog: false,
                user: null,
                client: null,
                componentKey: 0,
            }
        },
        methods: {
            ...authActions([
                'switch_user',
                'switch_client',
                'restore_user'
            ]),
            changeUser() {
                this.changeUserDialog = false;
                this.switch_user(this.user.id);
            },
            goBackToInitialUser() {
                this.changeUserDialog = false;
                this.restore_user();
            },
            changeClient() {
                this.changeClientDialog = false;
                this.switch_client(this.client.id);
            },
            goBackToInitialClient() {
                this.changeClientDialog = false;
                this.restore_user();
            },
            logout() {
                this.$store.commit('auth/logout');
                this.$store.commit('auth/setRedirect', this.$router.currentRoute.fullPath);
                this.$router.replace('/login');
            },
            quickSearch() {
                if (this.tracking != undefined && this.tracking != null && this.tracking !== '') {
                    this.$router.replace('/search?tracking=' + this.tracking)
                } else {
                    this.$router.replace('/search')
                }
                if (this.$route.name === 'Search') {
                    window.location.reload();
                }
                this.tracking = '';
            },
            backgroundColor: function () {
                if (process.env.NODE_ENV === "development") {
                    return 'headerStyleDev'
                } else {
                    return 'headerStyleProd'
                }
            },
            goApi() {
                if (this.$store.getters['auth/isInternalUser']) {
                    window.open(process.env.API_URL + '/documentation/private/index.html?key='+ encodeURI(this.$store.state.auth.key), '_blank');
                } else {
                    window.open(process.env.API_URL + '/documentation/public/index.html?key='+ encodeURI(this.$store.state.auth.key), '_blank');
                }
            }
        },
        computed: {
            ...authState([
                'key',
                'login_method',
                'is_logged_in',
                'switched_user',
                'switched_client'
            ]),
            ...authGetters([
                'name',
                'client_name',
                'username',
                'isInternalUser',
                'isAdmin',
                'hasAPIDocumentationPermission',
                'hasPermission',
                'hasPermissionRegion',
                'hasPermissionRegionId',
                'permissionRegions'
            ]),
            isAdmin() {
                return this.$store.getters['auth/hasPermission']('admin');
            },
            switchUserPermission: function () {
                return this.switched_user || this.isAdmin;
            },
            switchClientPermission: function () {
                if (this.clients === null) return this.switched_client;
                return this.switched_client || this.clients.length > 1;
            },
            itemsSubheaderDelivery: function () {
                // Taking items we want to display on subheader drawer + handling permissions
                let itemToolbar = router.routes.filter((item) => {
                    if (item.meta.subheader !== undefined) {
                        return item.meta.subheader === 'Delivery'
                    }
                    return false
                }).filter((route) => {
                    if (route.meta.permission !== undefined) {
                        return this.hasPermission(route.meta.permission);
                    }
                    return true
                });
                return itemToolbar
            },
            itemsSubheaderAdmin: function () {
                // Taking items we want to display on subheader 'Admin' + handling permissions
                let itemToolbar = router.routes.filter((item) => {
                    if (item.meta.subheader !== undefined) {
                        return item.meta.subheader === 'Admin'
                    }
                    return false
                }).filter((route) => {
                    if (route.meta.permission !== undefined) {
                        return this.hasPermission(route.meta.permission);
                    }
                    return true
                });
                return itemToolbar
            },
            itemsSubheaderManage: function () {
                // Taking items we want to display on subheader 'Manage' + handling permissions
                let itemToolbar = router.routes.filter((item) => {
                    if (item.meta.subheader !== undefined) {
                        return item.meta.subheader === 'Manage'
                    }
                    return false
                }).filter((route) => {
                    if (route.meta.permission !== undefined) {
                        return this.hasPermission(route.meta.permission);
                    }
                    return true
                });
                return itemToolbar
            },
            itemsSubheaderInventory: function () {
          // Taking items we want to display on subheader 'Inventory' + handling permissions
                let itemToolbar = router.routes.filter((item) => {
                    if (item.meta.subheader !== undefined) {
                        return item.meta.subheader === 'Inventory'
                    }
                    return false
                }).filter((route) => {
                    if (route.meta.permission !== undefined) {
                        return this.hasPermission(route.meta.permission);
                    }
                    return true
                });
                if (itemToolbar.length !== 0) {
                    return itemToolbar
                } else return false;
            },

            // client pricing subheader
            itemsSubheaderClientPricing: function () {
                let itemToolbar = router.routes.filter((item) => {
                    if (item.meta.subheader !== undefined) {
                        return item.meta.subheader === 'Client pricing'
                    }
                    return false
                }).filter((route) => {
                    if (route.meta.permission !== undefined) {
                        return this.hasPermission(route.meta.permission);
                    }
                    return true
                });
                if (itemToolbar.length !== 0) {
                    return itemToolbar
                } else return false;
            },

            // client tools subheader
            itemsSubheaderClientTools: function () {
                let itemToolbar = router.routes.filter((item) => {
                    if (item.meta.subheader !== undefined) {
                        return item.meta.subheader === 'Client tools'
                    }
                    return false
                }).filter((route) => {
                    if (route.meta.permission !== undefined) {
                        return this.hasPermission(route.meta.permission);
                    }
                    return true
                });
                if (itemToolbar.length !== 0) {
                    return itemToolbar
                } else return false;
            },
        },
        asyncComputed: {
            async users() {
                if (this.isAdmin) {
                    return await axios.get(process.env.API_URL + '/users')
                        .then((response) => {
                            if (response.status === 200) {
                                return response.data;
                            } else {
                                return [];
                            }
                        })
                        .catch((error) => {
                            return [];
                        })
                } else return [];
            },
            async clients() {
                if (this.$store.getters['auth/user_id'] <= 0) return [];
                return await axios.get(process.env.API_URL + '/clients')
                    .then((response) => {
                        if (response.status === 200) {
                            return Object.values(response.data).sort((a, b) => (a.name > b.name) ? 1 : -1);
                        } else {
                            return [];
                        }
                    })
                    .catch((error) => {
                        return [];
                    })
            }
        },
    }

</script>

<style>

</style>

<style scoped>

  .headerStyleProd {
       background-color: rgba(10, 140, 190, 0.8);
       backdrop-filter: initial;
     }

  .headerStyleDev {
    background-color: rgba(229, 6, 2, 0.9);
    backdrop-filter: initial;
  }

  /*.el1full {*/
  /*  display: block;*/
  /*  height: 100%;*/
  /*  width: 100%;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/components/util/InternalMenu.vue